var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLineAngleDownIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 123,
    height: 67,
    viewBox: "0 0 123 67",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_362_895)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.68 1.95002C8.94999 -0.699977 4.59999 -0.639977 1.94999 2.08002C-0.700009 4.80002 -0.640009 9.16002 2.07999 11.81L56.87 64.94L61.67 60.01L56.87 64.96C59.61 67.61 63.97 67.54 66.62 64.81C66.7 64.73 66.77 64.65 66.84 64.57L120.79 11.81C123.52 9.16002 123.58 4.80002 120.93 2.08002C118.28 -0.639977 113.92 -0.709977 111.2 1.95002L61.65 50.41L11.68 1.95002Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_362_895"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 122.88,
    height: 66.91,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAngleDownIcon);
export default __webpack_public_path__ + "static/media/line-angle-down-icon.a9f1910584a6f5f812bfd60fd7387198.svg";
export { ForwardRef as ReactComponent };